import { Controller } from "@hotwired/stimulus"
import { getGclid, sendHubspotForm } from "services/hubspot_helper"

// Shared account and assistant signup pages.
export default class extends Controller {
  static targets = ["form", "submitButton", "termsCheckbox"]

  connect() {
    $("#user_full_name").focus()
    this.#storeTrackingCookies()
    this.#toggleSubmit()
    this.#bindDropdowns()
  }

  disconnect() {
    this.#unbindDropdowns()
  }

  submit(event) {
    event.preventDefault()
    if (this.hasSubmitButtonTarget && this.submitButtonTarget.disabled) return

    const recaptcha = document.getElementById("recaptcha")
    if (!recaptcha || typeof window.grecaptcha === "undefined") {
      this.#sendSignupForm()
      return
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptcha.dataset.sitekey, { action: "signup" }).then((token) => {
        recaptcha.value = token
        this.#sendSignupForm()
      })
    })
  }

  toggleTerms() {
    this.#toggleSubmit()
  }

  #bindDropdowns() {
    this.$dropdowns = $(this.element).find(".dropdown")
    this.$dropdowns.on("click.accountsSharedSignup", function () {
      $(this).attr("tabindex", 1)
      $(this).toggleClass("active")
      $(this).find(".dropdown-menu").slideToggle(300)
    })

    this.$dropdowns.on("focusout.accountsSharedSignup", function () {
      $(this).removeClass("active")
      $(this).find(".dropdown-menu").slideUp(300)
    })

    this.$dropdowns.find(".dropdown-menu li").on("click.accountsSharedSignup", (event) => {
      const $item = $(event.currentTarget)
      const $dropdown = $item.parents(".dropdown")
      $dropdown.find("span").text($item.text())
      $dropdown.find("input").val($item.text().trim())

      if ($item.attr("id") === "use-case-other-source") {
        $(".use-case-other-version").removeClass("hide")
      } else if ($item.hasClass("close-use-case-other-textarea")) {
        $(".use-case-other-version .other-version").find("textarea").val("")
        $(".use-case-other-version").addClass("hide")
      }

      if ($item.attr("id") === "other-source") {
        $(".source-other-version").removeClass("hide")
      } else if ($item.hasClass("close-source-other-textarea")) {
        $(".source-other-version .other-version").find("textarea").val("")
        $(".source-other-version").addClass("hide")
      }
    })
  }

  #unbindDropdowns() {
    if (!this.$dropdowns) return
    this.$dropdowns.off(".accountsSharedSignup")
    this.$dropdowns.find(".dropdown-menu li").off(".accountsSharedSignup")
    this.$dropdowns = null
  }

  #sendSignupForm() {
    $(this.formTarget).ajaxSubmit({
      target: "#wrap",
      dataType: "json",
      data: { utm_params: window.location.search, gclid: getGclid() },
      beforeSubmit: () => {
        $(".login-block .alert").remove()
      },
      success: (response) => {
        if (response.success) {
          if (window.dataLayer) window.dataLayer.push({ event: "singup_form" })
          const user = response.user
          sendHubspotForm(
            user.last_name,
            user.first_name,
            user.email,
            user.company,
            user.job_title,
            user.country,
            user.account_id,
            user.source,
            user.source_other,
          )
          window.location.href = response.redirect_url
        } else {
          if (window.grecaptcha) window.grecaptcha.reset()
          this.#showError(response.message)
          this.#resetPlanKeys(response.plan_name, response.plan_key)
        }
      },
    })
  }

  #showError(messages) {
    const title = $("<h4>").text("Errors:")
    const error = $("<div>").addClass("alert alert-danger alert-signup").append(title)
    $.each(messages, function (_index, msg) {
      error.append($("<p>").text(msg))
    })
    $(".signup-form-wrap").prepend(error)
  }

  #resetPlanKeys(planName, planKey) {
    if (!planName) return

    const info = "In this form, you are signing up to create a new account with QuickBlox to get <b>#plan</b> account."
      .replace("#plan", planName)
    $(".plan_info").html(info)
    $("#user_plan_key").val(planKey)
  }

  #storeTrackingCookies() {
    $.cookie("qbutm", window.location.search)

    const gclid = new URLSearchParams(window.location.search).get("gclid")
    if (gclid && !$.cookie("gclid")) {
      $.cookie("gclid", gclid)
    }
  }

  #toggleSubmit() {
    if (!this.hasSubmitButtonTarget || !this.hasTermsCheckboxTarget) return

    const accepted = this.termsCheckboxTarget.checked
    this.submitButtonTarget.disabled = !accepted
    this.submitButtonTarget.classList.toggle("disabled", !accepted)
  }
}
